/* ============================================================================
   LAH — BANNER NA LISTA DE FAVORITOS
   Tema: Outubro (Claude 13.0)

   Um banner configuravel (Configuracoes do tema > Lahtref > Banner na lista
   de favoritos) para promocoes, informacao sobre lentes e afins.

   QUANDO APARECE: so quando a lista tem pelo menos UM OCULOS (de grau ou de
   sol). Lista vazia, ou so com acessorios, fica sem banner — o banner fala
   com quem ja escolheu uma armacao.

   ONDE: sempre abaixo do ULTIMO item da lista. A lista e redesenhada a cada
   mudanca (adicionar, remover, sincronizar com a conta); um observador
   recoloca o banner no fim toda vez, sem precisar tocar no lah-wishlist.js.

   COMO SABE QUE E OCULOS: pelo endereco do produto. Todo oculos da loja tem
   "oculos" no endereco (kora-oculos-de-grau, kora-oculos-de-sol);
   acessorios nao (lahtref-travel-case, kit-limpeza).

   RESPONSIVO: imagem propria para o celular (opcional) e para o desktop.
   Mesma margem lateral e mesmo arredondamento das caixas da gaveta.

   SEM IMAGEM: vira um cartao de cor com etiqueta, titulo, texto e botao.

   EVENTOS (GTM): lah_wishlist_banner_ver, lah_wishlist_banner_clique.
   ============================================================================ */

(function () {
    'use strict';

    if (window.__lahWlBanner) return;
    window.__lahWlBanner = true;

    var cfg = window.LAH_WL_BANNER;
    if (!cfg) return;

    var visto = false;

    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-wl-banner{position:relative;display:block;box-sizing:border-box;margin:18px var(--lah-wl-lateral,20px) 28px;' +
        'border-radius:14px;overflow:hidden;background:' + (cfg.fundo || '#0B1F16') + ';color:' + (cfg.corTexto || '#FFFFFF') + ';' +
        'text-decoration:none;font-family:Helvetica,"Helvetica Neue",Arial,sans-serif;-webkit-tap-highlight-color:transparent;}' +
        '.lah-wl-banner picture,.lah-wl-banner img{display:block;width:100%;height:auto;}' +
        '.lah-wl-banner__vela{position:absolute;inset:0;pointer-events:none;}' +
        '.lah-wl-banner__conteudo{position:absolute;inset:0;display:flex;flex-direction:column;align-items:flex-start;gap:6px;padding:18px 20px;}' +
        '.lah-wl-banner__conteudo--base{justify-content:flex-end;}' +
        '.lah-wl-banner__conteudo--topo{justify-content:flex-start;}' +
        '.lah-wl-banner__conteudo--centro{justify-content:center;}' +
        '.lah-wl-banner--sem-imagem .lah-wl-banner__conteudo{position:relative;inset:auto;min-height:130px;padding:22px;}' +
        '.lah-wl-banner__selo{display:inline-block;padding:4px 10px;border:1px solid currentColor;border-radius:999px;' +
        'font-size:10.5px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;}' +
        '.lah-wl-banner__titulo{margin:0;font-size:18px;font-weight:600;line-height:1.2;}' +
        '.lah-wl-banner__texto{margin:0;font-size:13.5px;line-height:1.45;opacity:.92;}' +
        '.lah-wl-banner__botao{display:inline-block;margin-top:8px;padding:9px 16px;border-radius:999px;' +
        'background:#FFFFFF;color:#111111;font-size:12.5px;font-weight:600;}' +
        '@media (min-width:1000px){.lah-wl-banner{margin-left:var(--lah-wl-lateral,24px);margin-right:var(--lah-wl-lateral,24px);}' +
        '.lah-wl-banner__titulo{font-size:20px;}.lah-wl-banner__conteudo{padding:22px 24px;}}';
    document.head.appendChild(estilo);

    function esc(str) {
        var d = document.createElement('div');
        d.textContent = str == null ? '' : String(str);
        return d.innerHTML;
    }

    function temOculos(lista) {
        return [].some.call(lista.querySelectorAll('.lah-wishlist-item a[href]'), function (a) {
            return /\/products\/[^?#]*oculos/i.test(a.getAttribute('href') || '');
        });
    }

    function montar() {
        var temImagem = !!(cfg.img || cfg.imgMobile);
        var temTexto = !!(cfg.selo || cfg.titulo || cfg.texto || cfg.botao);
        var tag = cfg.link ? 'a' : 'div';
        var html = '<' + tag + ' class="lah-wl-banner' + (temImagem ? '' : ' lah-wl-banner--sem-imagem') + '" data-lah-wl-banner' +
            (cfg.link ? ' href="' + esc(cfg.link) + '"' : '') + '>';

        if (temImagem) {
            var desk = cfg.img || cfg.imgMobile;
            var mob = cfg.imgMobile || cfg.img;
            html += '<picture>' +
                '<source media="(min-width: 1000px)" srcset="' + esc(desk) + '">' +
                '<img src="' + esc(mob) + '" alt="' + esc(cfg.titulo || '') + '" loading="lazy">' +
                '</picture>';

            if (temTexto && cfg.escurecer > 0) {
                var a = (cfg.escurecer / 100).toFixed(2);
                var dir = cfg.posicao === 'topo' ? '180deg' : (cfg.posicao === 'centro' ? '0deg' : '0deg');
                var fundo = cfg.posicao === 'centro'
                    ? 'rgba(0,0,0,' + a + ')'
                    : 'linear-gradient(' + dir + ', rgba(0,0,0,' + a + ') 0%, rgba(0,0,0,0) 70%)';
                html += '<span class="lah-wl-banner__vela" style="background:' + fundo + '"></span>';
            }
        }

        if (temTexto) {
            html += '<span class="lah-wl-banner__conteudo lah-wl-banner__conteudo--' + esc(cfg.posicao || 'base') + '">' +
                (cfg.selo ? '<span class="lah-wl-banner__selo">' + esc(cfg.selo) + '</span>' : '') +
                (cfg.titulo ? '<p class="lah-wl-banner__titulo">' + esc(cfg.titulo) + '</p>' : '') +
                (cfg.texto ? '<p class="lah-wl-banner__texto">' + esc(cfg.texto) + '</p>' : '') +
                (cfg.botao ? '<span class="lah-wl-banner__botao">' + esc(cfg.botao) + '</span>' : '') +
                '</span>';
        }

        return html + '</' + tag + '>';
    }

    function aplicar(lista) {
        var atual = lista.querySelector('[data-lah-wl-banner]');

        if (!temOculos(lista)) {
            if (atual) atual.remove();
            return;
        }

        if (atual && atual === lista.lastElementChild) return;
        if (atual) atual.remove();

        lista.insertAdjacentHTML('beforeend', montar());

        if (!visto) {
            visto = true;
            try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'lah_wishlist_banner_ver' }); } catch (e) {}
        }
    }

    function iniciar() {
        var lista = document.querySelector('[data-lah-wishlist-list]');
        if (!lista) return;

        aplicar(lista);

        if (window.MutationObserver) {
            new MutationObserver(function () { aplicar(lista); }).observe(lista, { childList: true });
        }

        lista.addEventListener('click', function (e) {
            if (!e.target.closest || !e.target.closest('[data-lah-wl-banner]')) return;
            try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'lah_wishlist_banner_clique' }); } catch (err) {}
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
})();
